import type React from "react";

import { useCurrentPathMatch } from "hooks/useCurrentPathMatch";
import { useRedirect } from "hooks/useRedirect";

import { CssIcon } from "styles/helpers/layout";

import { StyledTab } from "./NavigationTabs.styled";

export interface NavigationTabProps {
  children: string;
  dataCy?: string;
  icon?: string;
  activeIcon?: string;
  destinationUrl: string;
}

export const NavigationTab: React.FC<NavigationTabProps> = ({
  dataCy,
  children: label,
  icon,
  activeIcon,
  destinationUrl,
}) => {
  const { redirectToUrl } = useRedirect();
  const { currentRouteMatches } = useCurrentPathMatch();

  const isActive = currentRouteMatches(destinationUrl);

  const onTabClick = () => {
    if (!isActive) {
      redirectToUrl(destinationUrl);
    }
  };

  return (
    <StyledTab
      data-cy={dataCy}
      data-active={isActive}
      role="link"
      $isActive={isActive}
      onClick={onTabClick}
    >
      {icon && <CssIcon iconName={isActive && activeIcon ? activeIcon : icon} />}
      {label}
    </StyledTab>
  );
};
